import styled from "styled-components";

import { breakpoints } from "@/styles/breakpoints";

export const StyledCategoryCard = styled.div`
    position: relative;
    display: flex;
    width: 100%;
    min-height: 91px;
    cursor: pointer;
    background: var(--color-white);
    border-radius: var(--radius-5);
    box-shadow: 0 2px 2px rgba(0, 0, 0, 0.15);
    &:focus {
        background-color: var(--color-grey-400);
    }
    @media ${breakpoints.mdMax} {
        height: 112px;
    }
    @media ${breakpoints.sm} {
        height: 80px;
    }
    .infos {
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        padding: 0 10px 5px 10px;
        text-align: left;
        color: var(--color-secondary);
        .count {
            font-size: var(--size-24);
            font-weight: var(--weight-600);
        }
        .name {
            font-size: var(--size-16);
            @media ${breakpoints.xs} {
                font-size: var(--size-16);
            }
        }
    }
    svg {
        position: absolute;
        top: 0;
        right: 0;
        width: 86px;
        height: 68px;
        @media ${breakpoints.mdMax} {
            width: 86px;
            height: 68px;
        }
        @media ${breakpoints.xs} {
            width: 68px;
            height: 53px;
        }
    }
`;
